module.exports = __webpack_public_path__ + "img/czzn_034.216c52c5.png";